import { createClient } from 'contentful';

const client = createClient({
  space: 'xpckm8g47k10', 
  accessToken: 'jCvBFbNBstia0e9P_WZjKS7ttNvEXbA3Cw3TbruN6UY' 
});

export default client;
